(() => {
  function initGallery(root = document) {
    root.querySelectorAll('[data-volt-product]').forEach(product => {
      if (product.dataset.galleryReady) return;
      product.dataset.galleryReady = 'true';
      const main = product.querySelector('[data-gallery-main] img');
      const thumbs = [...product.querySelectorAll('[data-gallery-thumb]')];
      if (!main || thumbs.length < 2) return;
      thumbs.forEach(button => button.addEventListener('click', () => {
        main.src = button.dataset.imageSrc;
        main.removeAttribute('srcset');
        thumbs.forEach(item => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      }));
    });
  }
  document.addEventListener('DOMContentLoaded', () => initGallery());
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
  initGallery();
})();
